// Dashboard cards FilterChip defaults — EN + TR.
//
// Wave-1 Day 3 wiring. DashboardCards.FilterBar renders two prop-driven
// FilterChips ('Today' + 'All channels' EN default). Caller can override
// labels by passing custom chips; this dict supplies the locale-aware
// defaults used by SellerHome / AdminHome / SupplyHome.

import type { LocalizedDict } from '../index'

type DashboardCardsStrings = {
  filters: {
    today: string
    allChannels: string
  }
}

export const dashboardCardsI18n: LocalizedDict<DashboardCardsStrings> = {
  en: {
    filters: {
      today: 'Today',
      allChannels: 'All channels',
    },
  },
  tr: {
    filters: {
      today: 'Bugün',
      allChannels: 'Tüm kanallar',
    },
  },
}
